export type AuthMessageSeverity = "error" | "info" | "success"

export interface AuthMessage {
  message: string
  severity: AuthMessageSeverity
}

const authMessages: Record<string, AuthMessage> = {
  entra_verification_required: {
    message:
      "Check your email to verify this Microsoft account. Open the verification link in this browser before continuing.",
    severity: "info",
  },
  entra_verification_complete: {
    message:
      "Your Microsoft account has been verified. Sign in with Microsoft again to continue.",
    severity: "success",
  },
  entra_verification_failed: {
    message:
      "This verification link is invalid or has expired. Start a new Microsoft sign-in to request another email.",
    severity: "error",
  },
}

const storageKey = "mobilemind.auth_message"

/**
 * Returns a recognized authentication message and removes it from the URL.
 */
export function consumeAuthMessage(): AuthMessage | null {
  const url = new URL(window.location.href)
  const code = url.searchParams.get("auth_message")
  if (code && authMessages[code]) {
    setPersistedMessage(code)

    url.searchParams.delete("auth_message")
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}${url.hash}`
    )
    return authMessages[code]
  }

  const persistedCode = getPersistedMessage()
  return persistedCode ? authMessages[persistedCode] ?? null : null
}

function getPersistedMessage(): string | null {
  try {
    return window.sessionStorage.getItem(storageKey)
  } catch {
    return null
  }
}

function setPersistedMessage(code: string | null): void {
  try {
    if (code) {
      window.sessionStorage.setItem(storageKey, code)
    } else {
      window.sessionStorage.removeItem(storageKey)
    }
  } catch {
    // The current page still renders the message when storage is unavailable.
  }
}
